
//10
Object.defineProperty(exports, "__esModule", { value: true });
require("../../hocs/Focusable/Focusable.st.css");
module.exports.default = require("stylable/runtime").create(
    "root",
    "buttonnext758610631",
    {"root":"buttonnext758610631--root","content":"buttonnext758610631--content","prefix":"buttonnext758610631--prefix","suffix":"buttonnext758610631--suffix"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/button-next/button-next.st.css
// module id = 128
// module chunks = 0